import React, { memo } from 'react';

export const DotField = memo(() => (
  <div className="FreeTrial__DotField" aria-hidden="true">
    <svg width="100%" height="100%">
      <defs>
        <pattern id="trial-scan-dots" width="22" height="22" patternUnits="userSpaceOnUse">
          <circle cx="2" cy="2" r="1.2" fill="#c7d2fe" fillOpacity=".14" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#trial-scan-dots)" />
    </svg>
  </div>
));
